// Snackbar constants usesd as a reference in the app to show the snackbar message
const SNACK_CONST = {};

// Currency constant used in the app To show the currency in the app
const CURRENCY = "RON";

// Regular expressions for validation

// OTP regex for 6 digit OTP
const OTP_REGEX = /^\d{6}$/;

// Email regex for validating email addresses
const EMAIL_REGEX =
  /^[^\s@]+@[^\s@]+\.(com|net|org|edu|gov|mil|io|co|uk|us|in|info|biz|tv|me|xyz|ai|ca|au|de|fr|jp|cn|es|it|nl|ru|br|za|ch|se|no|dk|fi|pl|gr|mx|pt|ar|be|hk|sg|nz|id|my|ph|th|vn|kr)$/i;

// Password regex for validating passwords with at least 8 characters, one uppercase letter, and one special character
const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;

// CUI regex for validating CUI
const CUI_REGEX = /^RO\d{8}$/;

// Cleaning service ID used in the app
const CLEANING_SETVICE_ID = "6746e890abfebd01600040e0";

// Car service ID used in the app
const CAR_SETVICE_ID = "6746e8dfabfebd01600040e8";

// Constants for request types used in API calls
const REQUEST_TYPE = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

// API endpoints used in the app for various functionalities
const END_POINTS = {
  // User Authentication endpoints

  checkCui: "user/check-cui",
  sendCodeUser: "user/send-code",
  verifyCode: "verify-code",
  registerUser: "user/register",
  loginUser: "user/login",
  updateUser: "user/update",
  verifyPasswordUser: "user/verify-password",
  forgetPasswordUser: "user/forget-password",
  changePasswordUser: "user/change-password",
  joinWaitlist: "send/pre-registration-email",
  updateUserBankDetail: "user/bank-details",
  userCreateWithdrawRequest: "user/withdraw-request",
  getUserWithdrawRequest: "user/withdraw-request",

  // Chats
  getAllChatsById: "chat/messages",
  createChatWithWorker: "chat/create/user-with-worker",
  getAppointmentChat: "company/appointment/get-chat",

  // User notification endpoints

  getUserNotification: "admin/notification/get-by-role",
  markReadNotification: "notification/mark-all-read",

  // Ecomerce categories endpoints

  getAllCategories: "categories",
  getAllSubCategories: "sub-categories",

  // Service Sub Categorires
  // getServiceSubCategory: "admin/service-sub-category/get-by-id",
  getServiceSubCategory: "services",

  // Products endpoints

  getAllProducts: "supplier/product/get-all",
  getProductDetailsByUrl: "supplier/product/detail-url",
  getRelatedProducts: "supplier/product/get-related",
  addProductReview: "supplier/product/add-review",
  getTopRatedProducts: "supplier/product/get-top",
  getAllProductsByCategoryId: "supplier/product/category/get",
  getSimpleProducts: "simple-product/get",

  // Address endpoints

  createUserAddress: "user/address/create",
  getUserAddress: "user/address/get-all",
  getUserAddressDetail: "user/address/detail",
  updateUserAddress: "user/address/updated",
  deleteUserAddress: "user/address/delete",

  // Order endpoints

  createOrder: "supplier/order/create",
  getUserOrders: "supplier/order/get-users",
  getOrderDetail: "supplier/order/detail",
  updateOrderStatus: "supplier/order/update-status",
  createEcomPaymentIntent: "supplier/payment-intent/create",

  // Admin Setting Endpoints

  getAdminSetting: "admin/setting/get-latest",

  // Admin Subservice Endpoints

  getAllSubServices: "admin/services/get-all",
  getSubscriptionByRole: "admin/subscription/get-by-role",

  // Worker Endpoints

  getAllWorkersBySubserviceId: "worker/get-by-id",
  getWorkerByCordinates: "worker/cordinates/get",
  getWorkerDetail: "worker/detail",
  addReviewInWorker: "worker/add-review",

  // Company Service

  getCompanyServiceDetail: "company/service/get-detail",

  // Appointment endpoints

  createAppointment: "company/appointment/create",
  getAllAppointmentsByUserId: "company/appointment/get-by-userId",
  getAppointmentDetail: "company/appointment/detail",
  cancelAppointment: "appointment/cancel",

  // Admin Apis
  gatAdminFaqByUserType: "admin/faq/get",

  // Notification

  getUserNotification: "user/notification/get-by-role",

  // Get Detail

  getUserDetail: "user/detail",

  // Wallet History

  getUserWalletHistory: "user/wallet-history/get",

  // Bank Accounts

  getUserBankAccount: "user/bank-account/get",
  createUserBankAccount: "user/bank-account/create",
  removeUserBankAccount: "user/remove-bank-account",

  // Stripe Connected Account

  getUserStripeConnectedAccount: "user/connected-account/get",
  connectUserStripeAccount: "user/account-connect",
  createOnboardingLink: "user/onboard-link/create",
  removeStripeAccount: "user/connected-account/remove",
  withdrawUserAmount: "user/amount/withdraw",

  // Contact Support
  contactSupport: "contact-support",

  // User Package
  userPackageCreate: "user/package/create",
  getAllUserPackage: "user/package/get",
  userPackageDetail: "user/package/detail",
  userPackageDetailByUrl: "user/package/url",
  packages: "packages",

  // Blogs
  getAllBlogs: "blogs",
  getBlogDetail: "blog/detail",
};

export {
  EMAIL_REGEX,
  PASSWORD_REGEX,
  OTP_REGEX,
  REQUEST_TYPE,
  END_POINTS,
  SNACK_CONST,
  CURRENCY,
  CLEANING_SETVICE_ID,
  CAR_SETVICE_ID,
  CUI_REGEX
};
